const E = "change";
export {
  E as CHANGE_EVENT
};
